import { ChangeEvent } from "react";
import { Box, Checkbox, FormControlLabel, Link, Typography } from "@mui/material";


type MarketingCheckboxesProps = {
  isSubmittingAgreement: boolean;
  handleTermsAgreementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handlePromotionChange: (event: any) => void;
  isSendMonthlyNewsletter: boolean;
};

export default function MarketingCheckboxes({
  isSubmittingAgreement,
  handleTermsAgreementChange,
  handlePromotionChange,
  isSendMonthlyNewsletter
}: MarketingCheckboxesProps) {

  return (
    <Box sx={{ p: 1, '& .MuiCheckbox-root': { mt: -1 }, '& .MuiFormControlLabel-root': { alignItems: 'flex-start' } }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isSubmittingAgreement}
            onChange={handleTermsAgreementChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        sx={{ mb: 1 }}
        label={
          <Typography variant='body2'>
            I understand and agree with the{' '}
            <Link target="_blank" href="https://www.carbonclick.com/legal/terms-business/">
              Terms & Conditions
            </Link>{' '}and{' '}
            <Link target="_blank" href="https://www.carbonclick.com/legal/privacy-policy">
              Privacy Policy
            </Link>.
          </Typography>
        }
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={isSendMonthlyNewsletter}
            onChange={handlePromotionChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={
          <Typography variant='body2'>
            I want to receive product updates, useful resources and promotions via email.
          </Typography>
        }
      />
    </Box>
  );
}
